

















































import Vue from 'vue'
import { ConfigurationDescriptionLanguage, UiLanguageItem, UiLanguageList } from '@/types'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import DescriptionLanguagesDialog from '@/components/settings/configuration/DescriptionLanguagesDialog.vue'

interface ComponentData {
  loading: boolean
  inSaveProgress: boolean
  valid: boolean
  showDescriptionLanguagesDialog: boolean
  isEdit: boolean

  code: any | null
  bezeichnung: string | null
  languagesDialogDescriptionData: ConfigurationDescriptionLanguage[]
  list: any[]
  MWStNr: any | null
  LeitWährung: any | null
  AufbauderReferenznummer: any | null
  Teilnehmernummer: any | null
  Zielkonto: any | null
  Adresse: any | null
  UnternehmensId: any | null
  HandelsregisterNr: any | null
}

export default Vue.extend({
  name: 'ProfitCenterForm',

  components: {
    DescriptionLanguagesDialog
  },

  props: {
    profitCenterId: Number,
    isCreate: Boolean,
    isUpdate: Boolean
  },

  data (): ComponentData {
    return {
      loading: false,
      inSaveProgress: false,
      valid: false,
      showDescriptionLanguagesDialog: false,
      isEdit: false,

      code: null,
      bezeichnung: null,
      languagesDialogDescriptionData: [],
      list: [],
      MWStNr: null,
      LeitWährung: null,
      AufbauderReferenznummer: null,
      Teilnehmernummer: null,
      Zielkonto: null,
      Adresse: null,
      UnternehmensId: null,
      HandelsregisterNr: null,
    }
  },

  watch: {
    profitCenterId (newVal: number): void {
      if(newVal && newVal !== 0) {

      }
    }
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onDescriptionLanguagesClick (): void {
      this.showDescriptionLanguagesDialog = true
    },

    onDescriptionLanguagesDialogSave (data: ConfigurationDescriptionLanguage[]): void {
      this.languagesDialogDescriptionData = data
      const foundDescription: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      this.bezeichnung = foundDescription ? foundDescription.text : null
      this.onDescriptionLanguagesDialogClose()
    },

    onDescriptionLanguagesDialogClose (): void {
      this.showDescriptionLanguagesDialog = false
    },

    onSaveClick (): void {

    },

    onCancelClick (): void {
      this.$emit('cancel')
    }
  },

  mounted () {
    this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })
  }

})
